<script setup lang="ts">
import {
  mdiLoginVariant,
  mdiAccountBoxEditOutline,
  mdiAccountBoxPlusOutline,
  mdiHistory,
} from '@mdi/js'

import DateTimeField from '@/shared/components/date/DateTimeField.vue'
import MenuButton from '@/shared/components/button/MenuButton.vue'
import ListMenuItem from '@/shared/components/list-menu/ListMenuItem.vue'

interface Props {
  firstName?: string
  lastName?: string
  loginDate?: string
  updatedBy?: string
  updateDate?: string
  createdBy?: string
  createdDate?: string
  loading?: boolean
}

defineProps<Props>()

const model = defineModel<boolean>({ required: true })
</script>

<template>
  <MenuButton
    v-model="model"
    :title="$t('glossary.changeLog')"
    :icon="mdiHistory"
    :loading="loading"
  >
    <ListMenuItem
      v-if="loginDate"
      :label="`${firstName} ${lastName}` || $t('glossary.unknownUser')"
      :icon="mdiLoginVariant"
    >
      {{ $t('glossary.lastSignIn') }}:
      <DateTimeField :value="loginDate" />
    </ListMenuItem>
    <ListMenuItem
      v-if="updateDate"
      :label="updatedBy || $t('glossary.unknownUser')"
      :icon="mdiAccountBoxEditOutline"
    >
      {{ $t('glossary.updated') }}:
      <DateTimeField :value="updateDate" />
    </ListMenuItem>
    <ListMenuItem :label="createdBy || $t('glossary.unknownUser')" :icon="mdiAccountBoxPlusOutline">
      {{ $t('glossary.created') }}:
      <DateTimeField v-if="createdDate" :value="createdDate" />
    </ListMenuItem>
  </MenuButton>
</template>
